export const guid = () => {
  const s4 = () => {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1);
  };
  const time = new Date().getTime();
  //return id of format 'aaaaaaaa'-'aaaa'-'aaaa'-'aaaa'-'aaaaaaaaaaaa'
  return s4() + s4() + "-" + s4() + "-" + s4() + "-" + s4() + "-" + time;
};

export const transformTime = (sec) => {
  return new Date(sec * 1000).toISOString().substr(11, 8);
};

export const awaiter = (m) => new Promise((r) => setTimeout(r, m));

export const supportedPreviewFormats = [
  "image/jpeg",
  "image/png",
  "image/gif",
  "image/bmp",
  "image/webp",
  "image/svg+xml",
  // "video/mp4",
  // "video/webm",
  // "video/quicktime",
  // "video/x-matroska",
  // "audio/mpeg",
  // "audio/ogg",
  // "audio/wav",
  // "application/pdf",
  // "application/zip",
  // "application/x-rar-compressed",
  // "application/x-tar",
  // "application/x-bzip2",
];
